import { useTranslations } from '@vocab/react';
import { Alert, List, Stack, Text, TextLink } from 'braid-design-system';
import React from 'react';

import { events, link } from 'src/modules/analyticsTracker';
import { getBrandingGuidelinesUrl } from 'src/utils/urls';

import translations from './.vocab';

export interface AsiaBrandAlertMessageProps {
  isOnListPage?: boolean;
}

export const AsiaBrandAlertMessage = ({
  isOnListPage = false,
}: AsiaBrandAlertMessageProps) => {
  const { t } = useTranslations(translations);
  const onBrandingGuidelinesClick = () => {
    link(events.BRANDING_GUIDELINES_INTERACTED);
  };

  return (
    <Alert tone="caution">
      <Stack space="medium">
        {isOnListPage ? (
          <Text>
            {t('Some of your cover images are')}{' '}
            <TextLink
              weight="weak"
              href={getBrandingGuidelinesUrl()}
              target="_blank"
              onClick={onBrandingGuidelinesClick}
            >
              {t('not the right size.')}{' '}
            </TextLink>
            {t('Update by:')}
          </Text>
        ) : (
          <Text>{t('This cover image isn’t displaying well. Update by:')}</Text>
        )}
        <List>
          <Text>{t('repositioning the image')}</Text>
          <Text>{t('replacing with a new image')}</Text>
        </List>
      </Stack>
    </Alert>
  );
};
